import { render, staticRenderFns } from "./grouplessons.vue?vue&type=template&id=668eb6d2&"
import script from "./grouplessons.vue?vue&type=script&lang=js&"
export * from "./grouplessons.vue?vue&type=script&lang=js&"
import style0 from "./grouplessons.vue?vue&type=style&index=0&id=668eb6d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports